export const LOAD_OPEN_INCIDENT = "LOAD_OPEN_INCIDENT";
export const LOAD_OPEN_INCIDENT_SUCCESS = "LOAD_OPEN_INCIDENT_SUCCESS";
export const LOAD_OPEN_INCIDENT_FAILED = "LOAD_OPEN_INCIDENT_FAILED";
export const LOAD_CLOSE_INCIDENT = "LOAD_CLOSE_INCIDENT";
export const LOAD_CLOSE_INCIDENT_SUCCESS = "LOAD_CLOSE_INCIDENT_SUCCESS";
export const LOAD_CLOSE_INCIDENT_FAILED = "LOAD_CLOSE_INCIDENT_FAILED";
export const SORT_INCIDENTS = "SORT_INCIDENTS";
export const SELECT_INCIDENT_SEARCH = "SELECT_INCIDENT_SEARCH";
export const SELECT_INCIDENT_PRIORITY_FILTER = "SELECT_INCIDENT_PRIORITY_FILTER";
export const SELECT_INCIDENT_STATUS_FILTER = "SELECT_INCIDENT_STATUS_FILTER";
export const CLEAR_INCIDENT_STATUS_FILTER = "CLEAR_INCIDENT_STATUS_FILTER";
export const ADD_RESOLUTION_PROPOSAL_ACTION = "ADD_RESOLUTION_PROPOSAL_ACTION";
export const ADD_RESOLUTION_PROPOSAL_ACTION_SUCCESS = "ADD_RESOLUTION_PROPOSAL_ACTION_SUCCESS";
export const ADD_RESOLUTION_PROPOSAL_ACTION_FAILED = "ADD_RESOLUTION_PROPOSAL_ACTION_FAILED";
export const ADD_COMMENT = "ADD_COMMENT";
export const ADD_COMMENT_SUCCESS = "ADD_COMMENT_SUCCESS";
export const ADD_COMMENT_FAILED = "ADD_COMMENT_FAILED";



// WEBPACK FOOTER //
// ./src/incidents/incidentActionTypes.js